export const ESTIMATE_BADGE_TEXT = "ประมาณการ";
export const EMPTY_FIGURE_TEXT = "–";
